import React, { useState, useContext, useEffect,useRef } from "react";
import { Row, Col, FormGroup, Label, Form } from "reactstrap";
import axios from "axios";
import { toast } from "react-toastify";
import MaterialTable from "material-table";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { UserContext } from "../../../context/UserContext";
import StarRatingComponent from "react-star-rating-component";
import "react-toastify/dist/ReactToastify.css";
import { Redirect } from "react-router";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import "../../../css/course-catelog.css";
import TextField from "@material-ui/core/TextField";

import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: "100%",
  },
  selectEmpty: {
    // marginTop: theme.spacing(1),
  },
}));

const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop) 
const Myskill = () => {
  const classes = useStyles();
  const context = useContext(UserContext);
  const [skilllist, setSkilllist] = useState([]);
  const [skillcategorylist, setSkillcategorylist] = useState([]);
  const [myskilllist, setMyskilllist] = useState([]);
  const [rating, setRating] = useState("");
  const [skill, setSkill] = useState("");
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [skillcategory, setSkillcategory] = useState("");
  const [newskillcat, setNewskillcat] = useState("");
  const [newskil, setNewskil] = useState("");
  const [editskill, setEditskill] = useState("");
  const [editrating, setEditrating] = useState("");
  const [edityear, setEdityear] = useState("");
  const [editmonth, setEditmonth] = useState("");
  const [prevskillid, setPrevskillid] = useState("");
  const [deleteid, setDeleteid] = useState("");
  const [editComponent, setEditComponent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const myRef = useRef(null)
  useEffect(() => {
    // Update the document title using the browser API
    getskills();
  }, []);
  const getskills = async () => {
    axios
      .post("LearnerProfile/myskills")
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          setSkillcategorylist(res.data.skillcategorylist);
          setMyskilllist(res.data.myskilllist);
          setSkilllist(res.data.skilllist);

          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };

  const onStarClick = (nextValue, prevValue, name) => {
    setRating(nextValue);
  };
  const sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    saveNewskill();
  };

  const saveNewskill = async () => {
    setLoading(true);
    if (rating === "" || skill === "") {
      toast.error("All Fields are mandatory");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (skill === null) {
      toast.error("Select Skill");
      await sleep(3000);
      setLoading(false);
      return;
    } else {
      var formData = new FormData();
      formData.append("scat", skill);
      formData.append("rating", rating);
      formData.append("year", year);
      formData.append("month", month);
      if (skillcategory) {
        formData.append("skcat", skillcategory);
      }
      if (newskillcat) {
        formData.append("newskcat", newskillcat);
      }
      if (newskil) {
        formData.append("newsk", newskil);
      }

      await axios
        .post("LearnerProfile/saveSkill", formData)

        .then((res) => {
          // console.log("res  ====");
          if (res.data.status === "200" || res.data.status === "100") {
            toast.success(res.data.msg);
            setMyskilllist(res.data.myskilllist);
            setLoading(false);
            //window.location.reload(true);
          } else {
            toast.error("Something went wrong");
          }
        });
    }
  };
  const deleterecord = (e, id) => {
   // alert("Are you sure want to delete")
   setOpen(true);
   setDeleteid(id);
   
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handledelete = () => {
    setOpen(false);
    deleteskills(deleteid);
  };
  const deleteskills = async (id) => {

    var formData = new FormData();
    formData.append("deleteid", id);
    axios
      .post("LearnerProfile/deleteSkill", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          toast.success("Deleted successfully.");
          setMyskilllist(res.data.myskilllist);

          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };

  const editrecord = (e, id) => {
    setEditComponent(true);
    updateskills(id);
  };
  const updateskills = async (id) => {
    var formData = new FormData();
    formData.append("ps", id);
    axios
      .post("LearnerProfile/editSkill", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          setEditskill(res.data.savedskill);
          setEditrating(res.data.savedrating);
          setEdityear(res.data.savedyear);
          setEditmonth(res.data.savedmonths);
          setPrevskillid(res.data.prevskillid);
          scrollToRef(myRef);
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };

  const onStareditClick = (nextValue, prevValue, name) => {
    setEditrating(nextValue);
  };
  const handlerSubmit = (e, skid) => {
    e.preventDefault();
    saveeditskill(skid);
  };

  const saveeditskill = async (skid) => {
    setLoading(true);
   
    var formData = new FormData();
    formData.append("ps", skid);
    formData.append("editskill", editskill);
    formData.append("erating", editrating);
    formData.append("year", edityear);
    formData.append("month", editmonth);
    await axios
      .post("LearnerProfile/saveEditSkill", formData)

      .then((res) => {
        // console.log("res  ====");
        if (res.data.status === "200" || res.data.status === "100") {
          toast.success(res.data.msg);
          setLoading(false);
          setMyskilllist(res.data.myskilllist);
          setEditComponent(false);
        } else {
          toast.error("Something went wrong");
        }
      }).catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };

  if (!context.user?.email) {
    return <Redirect to="/" />;
  }
  return (
    <div>
      <section class="padding-default2">
        <div class="panel panel-primary card">
          <div class="panel-heading"> Add Your Skills</div>

          <div class="padding-pannele">
            <Form>
              <Row>
                <Col xs="6" sm="12" md="6">
                  <FormGroup row>
                    <Col sm={12}>
                      <FormControl style={{ width: "90%" }}>
                        <InputLabel id="demo-simple-select-label">
                          Select Skill{" "}
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          name="skill"
                          id="skill"
                          onChange={(e) => setSkill(e.target.value)}
                        >
                          <MenuItem value="null">Select Skill </MenuItem>
                          {skilllist.map((option) => (
                            <MenuItem value={option.name}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Col>
                  </FormGroup>
                </Col>

                <Col xs="6" sm="12" md="6">
                  <FormGroup row>
                    <Label>
                      {" "}
                      <span class="rate">
                        {" "}
                        Self rating &nbsp;&nbsp;&nbsp;&nbsp;
                      </span>
                    </Label>
                    <div class="rate1">
                      <StarRatingComponent
                        name="rate1"
                        starCount={5}
                        value={rating}
                        onStarClick={onStarClick}
                        emptyStarColor="gray"
                        onStarHover={onStarClick}
                      />
                    </div>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="6" sm="12" md="6">
                  <Label>Your Experience - </Label>
                  <FormGroup row>
                    <Col sm={6}>
                      <FormControl style={{ width: "100%" }}>
                        <InputLabel id="demo-simple-select-label">
                          Select year
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          name="year"
                          id="year"
                          onChange={(e) => setYear(e.target.value)}
                        >
                          <MenuItem value={0}>0</MenuItem>
                          <MenuItem value={1}>1</MenuItem>
                          <MenuItem value={2}>2</MenuItem>
                          <MenuItem value={3}>3</MenuItem>
                          <MenuItem value={4}>4</MenuItem>
                          <MenuItem value={5}>5</MenuItem>
                          <MenuItem value={6}>6</MenuItem>
                          <MenuItem value={7}>7</MenuItem>
                          <MenuItem value={8}>8</MenuItem>
                          <MenuItem value={9}>9</MenuItem>
                          <MenuItem value={10}>10</MenuItem>
                          <MenuItem value={11}>11</MenuItem>
                          <MenuItem value={12}>12</MenuItem>
                          <MenuItem value={13}>13</MenuItem>
                          <MenuItem value={14}>14</MenuItem>
                          <MenuItem value={15}>15</MenuItem>
                        </Select>
                      </FormControl>
                    </Col>
                    <Col sm={6}>
                      <FormControl style={{ width: "100%" }}>
                        <InputLabel id="demo-simple-select-label">
                          Select month
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          name="month"
                          id="month"
                          onChange={(e) => setMonth(e.target.value)}
                        >
                          <MenuItem value={0}>0</MenuItem>
                          <MenuItem value={1}>1</MenuItem>
                          <MenuItem value={2}>2</MenuItem>
                          <MenuItem value={3}>3</MenuItem>
                          <MenuItem value={4}>4</MenuItem>
                          <MenuItem value={5}>5</MenuItem>
                          <MenuItem value={6}>6</MenuItem>
                          <MenuItem value={7}>7</MenuItem>
                          <MenuItem value={8}>8</MenuItem>
                          <MenuItem value={9}>9</MenuItem>
                          <MenuItem value={10}>10</MenuItem>
                          <MenuItem value={11}>11</MenuItem>
                          <MenuItem value={12}>12</MenuItem>
                        </Select>
                      </FormControl>
                    </Col>
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col xs="6" sm="12" md="6">
                  {skill === "Other" ? (
                    <FormGroup row>
                      <Col sm={12}>
                        <FormControl style={{ width: "90%" }}>
                          <InputLabel id="demo-simple-select-label">
                            Select Skill Category{" "}
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            name="skillcategory"
                            onChange={(e) => setSkillcategory(e.target.value)}
                            id="skillcategory"
                          >
                            {skillcategorylist.map((option) => (
                              <MenuItem value={option.name}>
                                {option.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Col>
                    </FormGroup>
                  ) : (
                    " "
                  )}
                </Col>
                <Col xs="6" sm="12" md="6">
                  {skill === "Other" && skillcategory !== "Other" ? (
                    <>
                      <FormGroup row>
                        <Col sm={12}>
                          <TextField
                            label="Enter New Skill "
                            style={{ width: "90%" }}
                            id="newskil"
                            name="newskil"
                            onChange={(e) => setNewskil(e.target.value)}
                          />
                        </Col>
                      </FormGroup>
                    </>
                  ) : (
                    ""
                  )}
                </Col>
              </Row>

              <Row>
                <Col xs="12" sm="12" md="12">
                  {skill === "Other" && skillcategory === "Other" ? (
                    <>
                      <FormGroup row>
                        <Col sm={6}>
                          <TextField
                            label="Enter New Skill Category"
                            style={{ width: "90%" }}
                            id="newskillcat"
                            name="newskillcat"
                            onChange={(e) => setNewskillcat(e.target.value)}
                          />
                        </Col>
                        <Col sm={6}>
                          <TextField
                            label="Enter New Skill "
                            style={{ width: "90%" }}
                            id="newskil"
                            name="newskil"
                            onChange={(e) => setNewskil(e.target.value)}
                          />
                        </Col>
                      </FormGroup>
                    </>
                  ) : (
                    ""
                  )}
                </Col>
              </Row>

              <div className="root">
                <div className="col-lg-12 text-center">
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={loading}
                    onClick={(e) => handleSubmit(e)}
                  >
                    Add
                  </Button>

                  {loading === true ? (
                    <CircularProgress
                      size={24}
                      color="green"
                      className="buttonProgress1"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <br />
            </Form>
          </div>
        </div>
      </section>
      <section class="padding-table">
        <div class="panel panel-primary card">
          <div class="panel-heading">My Skills</div>
          <div class="panel-body">
            <Row>
              <Col xs="10" sm="12" md="12">
                <span>
                  <MaterialTable
                    title="My Skills"
                    columns={[
                      { title: "Sr.No.", field: "srno" },
                      { title: "Skill", field: "skillname" },
                      {
                        title: "Rating",
                        field: "selfrating",
                        render: (rowData) => {
                          return (
                            <span
                              style={{ fontWeight: "bold", fontSize: "25.6px" }}
                            >
                              <StarRatingComponent
                                name="hover-feedback"
                                value={rowData.selfrating}
                                emptyStarColor="gray"
                                readOnly
                              />
                            </span>
                          );
                        },
                      },
                      {
                        title: "Experience",
                        field: "years",
                      },
                    ]}
                    data={myskilllist}
                    actions={[
                      {
                        //icon: EditIcon ,
                        icon: () => <EditIcon color={"primary"} />,
                        tooltip: "Edit",

                        onClick: (event, rowData) =>
                          editrecord(event, rowData.skid),
                      },
                      {
                        // icon: DeleteIcon,
                        icon: () => <DeleteIcon color={"secondary"} />,
                        tooltip: "Delete",
                        onClick: (event, rowData) =>
                          deleterecord(event, rowData.skid),
                      },
                    ]}
                    options={{
                      exportButton: true,
                      actionsColumnIndex: -1,
                    }}
                  />
                </span>
              </Col>
            </Row>
          </div>
        </div>
      </section>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{"Are you sure want to delete?"}</DialogTitle>
        <DialogContent>
          {/* <DialogContentText id="alert-dialog-slide-description">
          
          </DialogContentText> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            No
          </Button>
          <Button onClick={handledelete} color="primary">
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      
      {editComponent === true ? (
      <div ref={myRef}>
        <section class="padding-table">
          <div class="panel panel-primary card">
            <div class="panel-heading">Edit Skills</div>
            <div class="padding-pannele">
              <Form>
                <Row>
                  <Col xs="6" sm="12" md="6">
                    <FormGroup row>
                      <Col sm={12}>
                        <TextField
                          label="Select Skill "
                          style={{ width: "90%" }}
                          id="skill"
                          value={editskill}
                          name="skill"
                          readOnly
                        />
                      </Col>
                    </FormGroup>
                  </Col>
                  <Col xs="6" sm="12" md="6">
                    <FormGroup row>
                      <Label>
                        {" "}
                        <span class="rate">
                          {" "}
                          Self rating &nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                      </Label>

                      <div class="rate1">
                        <StarRatingComponent
                          name="rate1"
                          starCount={5}
                          value={editrating}
                          onStarClick={onStareditClick}
                          emptyStarColor="gray"
                          onStarHover={onStareditClick}
                        />
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs="6" sm="12" md="6">
                    <Label>Your Experience</Label>
                    <FormGroup row>
                      <Col sm={6}>
                        <FormControl style={{ width: "100%" }}>
                          <InputLabel id="demo-simple-select-label">
                            Select year
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            name="year"
                            id="year"
                            value={edityear}
                            onChange={(e) => setEdityear(e.target.value)}
                          >
                            <MenuItem value={0}>0</MenuItem>
                            <MenuItem value={1}>1</MenuItem>
                            <MenuItem value={2}>2</MenuItem>
                            <MenuItem value={3}>3</MenuItem>
                            <MenuItem value={4}>4</MenuItem>
                            <MenuItem value={5}>5</MenuItem>
                            <MenuItem value={6}>6</MenuItem>
                            <MenuItem value={7}>7</MenuItem>
                            <MenuItem value={8}>8</MenuItem>
                            <MenuItem value={9}>9</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={11}>11</MenuItem>
                            <MenuItem value={12}>12</MenuItem>
                            <MenuItem value={13}>13</MenuItem>
                            <MenuItem value={14}>14</MenuItem>
                            <MenuItem value={15}>15</MenuItem>
                          </Select>
                        </FormControl>
                      </Col>
                      <Col sm={6}>
                        <FormControl style={{ width: "100%" }}>
                          <InputLabel id="demo-simple-select-label">
                            Select month
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            name="month"
                            id="month"
                            value={editmonth}
                            onChange={(e) => setEditmonth(e.target.value)}
                          >
                            <MenuItem value={0}>0</MenuItem>
                            <MenuItem value={1}>1</MenuItem>
                            <MenuItem value={2}>2</MenuItem>
                            <MenuItem value={3}>3</MenuItem>
                            <MenuItem value={4}>4</MenuItem>
                            <MenuItem value={5}>5</MenuItem>
                            <MenuItem value={6}>6</MenuItem>
                            <MenuItem value={7}>7</MenuItem>
                            <MenuItem value={8}>8</MenuItem>
                            <MenuItem value={9}>9</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={11}>11</MenuItem>
                            <MenuItem value={12}>12</MenuItem>
                          </Select>
                        </FormControl>
                      </Col>
                    </FormGroup>
                  </Col>
                </Row>
              </Form>

              <div className="root">
                <div className="col-lg-12 text-center">
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={loading}
                    onClick={(e) => handlerSubmit(e, prevskillid)}
                  >
                    Update
                  </Button>

                  {loading === true ? (
                    <CircularProgress
                      size={24}
                      color="green"
                      className="buttonProgress1"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <br />
            </div>
          </div>
        </section>
        </div>  
      ) : (
        ""
      )}
    </div>
  );
};

export default Myskill;
